import { render, staticRenderFns } from "./XPerPageSelector.vue?vue&type=template&id=549a323e&"
import script from "./XPerPageSelector.vue?vue&type=script&lang=js&"
export * from "./XPerPageSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports